export class Utils {
    /**
     * Triggers a 'download file' popup which will download the contents
     */
    offerContentsAsDownloadableFile(contents, fileName = "download.txt", options) {
        const element = document.createElement("a");
        let file;
        if (typeof contents === "string") {
            file = new Blob([contents], { type: options?.mimetype ?? "text/plain" });
        }
        else {
            file = contents;
        }
        element.href = URL.createObjectURL(file);
        element.download = fileName;
        document.body.appendChild(element); // Required for this to work in FireFox
        element.click();
    }
}
